import React, { memo, useMemo } from 'react'
import { useRouter } from 'next/router'
import { QueryParamProvider as ContextProvider } from 'use-query-params'

export function QueryParamProvider(props) {
  const { children, ...rest } = props
  const router = useRouter()

  const location = useMemo(
    () => ({
      search: router.asPath.replace(/[^?]+/u, ''),
    }),
    [router.asPath]
  )

  const history = useMemo(() => {
    const currentParts = () => {
      const [path] = router.asPath.split('#')
      const pathnameMatch = path.match(/[^?]+/u)
      // Read the hash from window.location (authoritative) at call-time rather than a
      // value captured when the memo ran. A captured hash goes stale and gets re-applied
      // on every param change (e.g. re-adding #showings when opening a unit modal, which
      // then prevents the modal from scrolling into view).
      const hash = typeof window === 'undefined' ? '' : window.location.hash.replace(/^#/u, '')
      return { pathname: pathnameMatch ? pathnameMatch[0] : path, hash }
    }
    return {
      push: ({ search }) => {
        const { pathname, hash } = currentParts()
        router.push({ pathname, search, hash }, null)
      },
      replace: ({ search }) => {
        const { pathname, hash } = currentParts()
        router.replace({ pathname, search, hash }, null, { scroll: false })
      },
    }
  }, [router])

  return (
    <ContextProvider {...rest} history={history} location={location}>
      {children}
    </ContextProvider>
  )
}

export default memo(QueryParamProvider)
